.iconHoverable {
  &:hover {
    transform: scale(1.25);
    cursor: pointer;
  }
}

.iconDisabledUnbordered {
  > path {
    fill: var(--icon-soft);
  }
}

.iconDisabledBordered {
  > path:first-child {
    fill: var(--surface-default);
    stroke: var(--icon-soft);
  }

  > path:last-child {
    fill: var(--icon-soft);
  }
}
